import { FlowStateController } from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import { gsap } from "gsap";

import { EventsManager, FlowEvents, ReelsEvents } from "../../../abstracts/events/EventsManager";
import { fsConfig } from "../../config/ApocalypseConfig";
import { ApocalypseReelsView } from "../../modules/Reels/ApocalypseReelsView";
import { ApocalypseFsReel } from "../../modules/Reels/fs/ApocalypseFsReel";
import { IApocalypseReelAnimation } from "../../types/ApocalypseInterfaces";
import { ApocalypseCounter } from "../../utils/ApocalypseCounter";
import { ApocalypseNormalBetPresentation } from "../normal/ApocalypseNormalBetPresentation";

export class ApocalypseFreespinBetPresentation extends ApocalypseNormalBetPresentation {
    protected fsReels: ApocalypseFsReel[];
    protected fsLeftCounter: ApocalypseCounter;
    protected fsLeft: number = 3;

    constructor(protected id: string = `UCFreespinBetPresentation`) {
        super(id);
    }

    protected handleEvents(): void {
        EventsManager.on(ReelsEvents.GET_REELS_VIEW, (reelsView: ApocalypseReelsView) => {
            this.reelsView = reelsView;
        });

        EventsManager.on(ReelsEvents.GET_FREESPIN_REELS, (fsReels: ApocalypseFsReel[]) => {
            this.fsReels = fsReels;

            this.fsLeftCounter = this.reelsView.getFreespinContainer().fsLeftContainer.counter;
        });
    }

    protected get config(): IApocalypseReelAnimation {
        return fsConfig;
    }

    start(flowStateController: FlowStateController) {
        this.reels = this.fsReels;
        this.fsLeft =
            this.model.data.freespinsLeft === 0 && this.model.data.firstStage
                ? this.model.data.secondStageFsLeft - 1
                : this.model.data.freespinsLeft - 1;

        this.fsLeft = this.model.data.secondStage
            ? this.model.data.secondStageFsLeft - 1
            : this.fsLeft;

        gsap.delayedCall(this.model.data.isRestoreState ? 0.5 : 0, () => {
            super.start(flowStateController);
        });
    }

    protected finishPresentation() {
        super.finishPresentation();
    }

    protected override onDefaultStart() {
        super.onDefaultStart();
    }

    protected override onRestoreStart(): void {
        super.onRestoreStart();
    }

    protected override onBetStarted(): void {
        //here add skip screen
        // this.controller.setSkipCallback(() => {
        //     console.log(`test`);
        // });

        EventsManager.trigger(FlowEvents.BET_STARTED);

        this.fsLeftCounter.getUpdateCounterTextAnimation(this.fsLeft);

        // gsap.delayedCall(
        //     0.2,
        //     () => {
        //         this.keypad.setZeroBetSpinCounter(this.fsLeft);
        //     },
        //     undefined
        // );
    }
}
